import React from 'react';

import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';

import BaseModalAlertWrapper, { ModalVariant } from '@components/share/modal/baseModalAlertWrapper';

type EnrollmentExpiredDialogProps = {
  open?: boolean;
  onClose: typeof noop;
  onConfirm: typeof noop;
};

const EnrollmentExpiredDialog = ({ open = false, onClose, onConfirm }: EnrollmentExpiredDialogProps) => {
  const { t } = useTranslation('store_course');
  return (
    <BaseModalAlertWrapper
      variant={ModalVariant.WARNING}
      open={open}
      title={t('course_detail.header_banner.purchase.expired.modal.title')}
      description={t('course_detail.header_banner.purchase.expired.modal.subtitle')}
      paperStyle={{
        width: '490px',
      }}
      confirmText={t('course_detail.header_banner.purchase.expired.modal.button.text')}
      customIcon="fa-sharp fa-regular fa-book-open-cover"
      fullWidthConfirmButton
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default EnrollmentExpiredDialog;
